<template>
  <vx-card class="lg:p-8 w-full lg:w-9/12 fadeInLeft">
    <form @keyup.enter="submitForm">
      <div class="vx-card__title mb-4">
        <h4 class="mb-4">Регистрация</h4>
        <p>Заполните поля ниже</p>
      </div>

      <div class="mt-6">
        <vs-input
          label="Имя:"
          name="name"
          v-model="name"
          v-validate="'required'"
          class="w-full" />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
      </div>

      <div class="mt-6">
        <vs-input
          label="E-mail:"
          name="email"
          type="email"
          v-model="email"
          v-validate="'required|email'"
          class="w-full" />
        <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
      </div>

      <div class="mt-6">
        <password-input
          label="Пароль:"
          name="password"
          v-model="password"
          v-validate="'required|min:8'"
          ref="password"
          class="w-full" />
        <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
      </div>

      <div class="mt-6">
        <password-input
          label="Подтвердить пароль:"
          name="password_confirmation"
          v-model="password_confirmation"
          data-vv-as="password"
          v-validate="'required|confirmed:password'"
          class="w-full" />
        <span class="text-danger text-sm" v-show="errors.has('password_confirmation')">{{ errors.first('password_confirmation') }}</span>
      </div>

      <div class="mt-10 mb-6">
        <vs-checkbox v-model="policy" name="policy" v-validate="'required'" class="m-0 items-start">
          Я даю согласие на <a href="#">обработку своих персональных данных</a>
          и принимаю <a href="#">условия оферты</a>
        </vs-checkbox>
      </div>

      <div class="flex flex-wrap justify-between items-center">
        <p>Уже есть аккаунт? <router-link :to="{name: 'login'}">Войти</router-link></p>
        <vs-button class="float-right" @click.prevent="submitForm">Зарегистрироваться</vs-button>
      </div>
    </form>
  </vx-card>
</template>

<script>
import Auth from '../../api/http/models/auth/Auth'
import { mapActions } from 'vuex'
import errorsParsing from '../../mixins/errorsParsing'

export default  {
  data () {
    return {
      name: '',
      email: '',
      password: '',
      password_confirmation: '',
      policy: true
    }
  },
  mixins: [errorsParsing],
  methods: {
    ...mapActions(['fetchAuthUser']),
    async submitForm () {
      const validate = await this.$validator.validateAll()
      if (validate && this.policy) {
        const response = await Auth.register({
          name: this.name,
          email: this.email,
          password: this.password
        })

        if (response.status === 'success') {
          await this.fetchAuthUser()
          this.$router.push({ name: 'need_verify' })
        } else if (response.errors) {
          this.errorsParsing(response.errors)
        }
      }
    }
  }
}
</script>
